$(document).ready(function () {
    $('#code').mask('+000', {
        translation: {
            '0': {
                pattern: /[0-9]/,
                optional: true
            },
        },
        maxlength: 3
    });
    $('#phone').mask('000 000 00 00', {
        translation: {
            '0': {
                pattern: /[0-9]/,
                optional: false
            },
        },
        maxlength: 10
    });

    $('#birthdate').mask('40.50.2900', {
        translation: {
            '0': {
                pattern: /[0-9]/,
                optional: false
            },
            '2': {
                pattern: /[1-2]/,
                optional: false
            },
            '4': {
                pattern: /[0-3]/,
                optional: false
            },
            '5': {
                pattern: /[0-1]/,
                optional: false
            },
            '9': {
                pattern: /[0,9]/,
                optional: false
            },
        },
        maxlength: 6
    })
    //     , {
    //     onKeyPress: function(cep, e, currentField, options) {
    //         if (currentField.val().replace(/\D/g,'').charAt(1) === '8') {
    //             currentField.val('+7 (');
    //         }
    //     }
    // });
});

export function phoneFormat() {
    let pattern = /(\+7|8)[\s(]?(\d{3})[\s)]?(\d{3})[\s-]?(\d{2})[\s-]?(\d{2})/g;
    $('a.phone').each(function() {
        let $this = $(this);
        $this.text($this.text().replace(pattern, '+7 $2 $3 $4 $5'));
    });
}

// function dateFormat(date_time) {
//
//     // $('.datetime-utc, .date-utc').each(function () {
//     //     let $this = $(this);
//     //     let dateString = new Date($this.data('date'));
//     //     let string = dateString.toLocaleString('ru-RU', { 'dateStyle': 'long' });
//     //
//     //     if ($this.prop("classList").contains('datetime-utc')) {
//     //         string += ' ' + dateString.toLocaleString('ru-RU', { 'timeStyle': 'short'}) + ' ' + timezone;
//     //     }
//     //
//     //     $(this).text(string);
//     // })
// }

function prepareData(val) {
    const timezone = momentTz.tz.guess();
    for (let key in val) {
        if (typeof val[key] === 'string' || val[key] instanceof String) {
            if (key.includes('date')) {
                val[key] = momentTz.utc(val[key]).tz(timezone);
            }
        }
    }
}

function scrollTop(href) {
    $('html, body').stop().animate({
        'scrollTop': $(href).offset().top-100
    }, 300, function () {
        $(href).children().trigger('click')
    });
}

function makeNotification(header, body) {
    let $notification = $('#modal_notification');
    $notification.find('#exampleModalLongTitle').text(header);
    $notification.find('.modal-body>span').text(body);
    $notification.modal('show');
}

export function downloadFile(e) {
    e.preventDefault();
    const dataset = e.target.closest('.download').dataset;
    const filename = dataset.filename;
    const url = new URL(dataset.href, window.location.origin);

    if (filename) {
        url.searchParams.set('download', '1');
        url.searchParams.set('name', filename);
    }

    fetch(url.toString(), {
        credentials: 'same-origin',
    })
        .then((response) => {
            if (!response.ok) {
                throw new Error('File download failed');
            }

            return response.blob();
        })
        .then((blob) => {
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = filename || 'download';

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(blobUrl);
        })
        .catch((error) => {
            console.error(error);
            window.location.href = url.toString();
        });
}
